import React from 'react'
import { Button, Text } from '@shopify/polaris'
import { Link } from 'react-router-dom'
import { AddIcon } from 'img/icons/components'
import { formatDate, formatTime } from 'utils/dates'
import { isTaxAgentSelector } from '../../../../redux/selectors'

const DashboardPrimaryAction = ({ user, currentPlan, lastUploaded, t, onSubscriptionDialogOpen, navigate }) => {
	const IS_TAX_AGENT = isTaxAgentSelector(user)

	const handleAddTransactionClick = () => {
		if (
			(!user.is_manager &&
				!user.is_omp &&
				currentPlan &&
				!currentPlan.is_active &&
				!currentPlan.is_active_25 &&
				!currentPlan.is_active_sales_tax) ||
			(!user.is_manager && !user.is_omp && !currentPlan)
		) {
			onSubscriptionDialogOpen("subscription")
		} else {
			navigate("/transactions/import")
		}
	}

	return (
		<div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
			{lastUploaded && lastUploaded[0] && (
				<Text color='subdued'>
					<div style={{ textAlign: "right" }}>
						{t("home.lastTransUp")} <br />
						{lastUploaded[0] &&
							`${formatDate(
								lastUploaded[0].transactions_date_update
							)} ${formatTime(lastUploaded[0].transactions_date_update)}`}
					</div>
				</Text>
			)}

			{!IS_TAX_AGENT &&
				user.company.id !== user.tax_agent_company_id &&
				!user.is_omp && (
					<div style={{ width: '191px' }}>
						<Button
							icon={AddIcon}
							outline
							size='large'
							fullWidth
							onClick={handleAddTransactionClick}
						>
							{t("home.addTrans")}
						</Button>
					</div>
				)}
		</div>
	)
}

export default DashboardPrimaryAction

